import { NgModule } from '@angular/core';
import { Routes, RouterModule,ExtraOptions} from '@angular/router';
import { AuthGuard } from './shared/guard/auth.guard';

const routes: Routes = [
  {
    path: 'mobile',
    loadChildren: () =>
      import('./pages/mobile/mobile.module').then((m) => m.MobileModule),
    // canActivate: [AuthGuard],
    data: {
      tab: '',
      enableFilters: true,
      hideTopMenu: true,
      mobile: true,
    },
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'auth/login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'loginWithDialog',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'maintenance',
    loadChildren: () => 
      import('./pages/maintenance/maintenance.module').then(m => m.MaintenanceModule)
  },
  { path: '**', redirectTo: '/', pathMatch: 'full' },
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled', // Restores scroll position on navigation
  anchorScrolling: 'enabled', // Enables scrolling to fragments
  scrollOffset: [0, 50], // Adjusts offset for fixed headers
  useHash: false // Keep your existing setting
};

@NgModule({
  imports: [RouterModule.forRoot(routes,routerOptions)],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule { }
